import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";

const schema = z.object({
    // Basic Details
    name: z.string().min(1, "Project name is required"),
    type: z.string().min(1, "Project type is required"),
    
    // Autocomplete returns option objects; allow any, but require a value
    salesmanName: z.any().refine((val) => !!val, {
        message: "Salesman name is required",
    }),

    // Customer Details
    customerName: z.string().min(1, "Customer name is required"),
    customerPhoneNumber: z.string().min(1, "Customer phone number is required"),
    customerEmail: z.string().optional().refine(val => !val || z.string().email().safeParse(val).success, "Invalid email address"),
    customerStreetAddress: z.string().min(1, "Customer street address is required"),
    customerCity: z.string().min(1, "Customer city is required"),
    customerState: z.string().min(1, "Customer state is required"),
    customerZipCode: z.string().min(1, "Customer ZIP code is required"),
    customerCountry: z.string().min(1, "Customer county is required"),
});

const newProjectV2Resolver = zodResolver(schema);

export default newProjectV2Resolver;
